import React from 'react'
import { ReactComponent as ThankyouImage } from "../../images/thank-you/success.svg"
import "./forwaredmedicalThankYou.scss"

const ForwardedMedicalThankYou = () => {
  return (
    <>
        <div className='product-thankyou-page-container'>
            <div className='product-thankyou-page-content-container ModelMaxWidth540'>
            <ThankyouImage />
              <h1>Medical form completed successfully!</h1>
              <p>Thank you for completing your medical form, any changes or questions please speak to your practitioner.</p>
               
            </div>
        </div>
    </>
  )
}

export default ForwardedMedicalThankYou